import UploadService from './upload.service';

UploadService.$inject = ['$http'];

angular.module('$uploadModule', []).service('$upload', UploadService);



// WEBPACK FOOTER //
// ./src/app.js